<template>
    <div class="case">
        <div class="case_cennert">
            <h1>VR直播案例</h1>
            <p>精致宏大的三维场景，带您身临其境体验</p>
            <ul class="case_btn">
                <li 
                    v-for="(item,index) in case_btn" :key="index"
                    @click="listitem(index)"
                    :class="{'lishow':index ==lishow}"
                >
                    {{item}}
                </li>
            </ul>
               <ul class="cal_list">
                  <div data-aos="fade-right"
                   data-aos-offset="300"
                    data-aos-easing="ease-in-sine">
                <li v-for="(item,index) in list" :key="index">
                    <div class="cal_list_top">
                        <img
                            :src="item.img"
                            @mouseover="pop1(item,index)" 
                        />
                            <div class="top" v-if="cal_tf && indcal_tf === index"  @mouseleave="pop2(item)" @click="Product_Click(item)">
                                <div class="erweima">
                                    <div id="qrcode_max">
                                        <div id="qrcode" ref="qrcode">
                                                <div class="qrcode_Mask"></div>
                                        </div>
                                        <div class="qrcode_btn">
                                            点击进入
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="cal_list_bottom">
                        <h3>{{item.title}}</h3>
                        <p>{{item.des}}</p>
                    </div>
                    
                </li>
                </div>
            </ul>
         
            <div class="case_go">
                <router-link to="/cases" >
                    精品案例
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
    data(){
        return {
        cal_tf:false,
        indcal_tf:null,
        VR_display:false,
        lishow:0,
        link:null,
        case_btn:["VR展会直播","VR活动直播","VR购物直播"],
        list:'',
        exhibition:"",
        activity:"",
        shopping:""
        }
    },
     methods:{
        pop1(e,e1){
            this.cal_tf = true
            this.indcal_tf = e1;
            this.$nextTick(() => {
                this.qrcode(e.link);
            })
        },
        pop2(){
            this.cal_tf = false
        },
        qrcode(link) {
            let qrcode = new QRCode("qrcode", {
                width: 110, // 设置宽度，单位像素
                height: 110, // 设置高度，单位像素
                text:link // 设置二维码内容或跳转地址
            });
        },
        Product_Click(link_){
            if(link_.codeid == ''){
                return false
            }else{
                 this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
            }
        },
        close(){
            this.VR_display = false
        },
        listitem(index){
            this.lishow = index
            if(index == 0){
                this.list = this.exhibition
            }
            if(index == 1){
                this.list = this.activity
            }
            if(index == 2){
                this.list = this.shopping
            }

        },
        panorama(cate2,index){
                 this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                             cate:cate2,
                             page:0,
                             size:3         
                        }),    
                        )
                        .then(res => {
                          
                            if(index == 1){
                                this.list = res.data.data
                                for(var i=0;i<this.list.length;i++){
                                    this.list[i].img = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                }
                                this.exhibition = this.list
                            }
                            if(index == 2){
                                this.activity = res.data.data
                                for(var i=0;i<this.activity.length;i++){
                                    this.activity[i].img = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                }
                            }
                            if(index == 3){
                                this.shopping = res.data.data
                                for(var i=0;i<this.shopping.length;i++){
                                    this.shopping[i].img = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                }
                            }
                    })
        }
    },
    mounted(){
        this.panorama(11,1)
        this.panorama(12,2)
        this.panorama(13,3)
    }
    
}
</script>
<style scoped>
.if{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background:rgba(25,25,25,0.95);
}
.case{
    width: 100%;
    height: 828px;
    background: url("../../assets/imges/liveroadcast/case_bg.png");
}
.case_btn{
    width: 526px;
    height: 51px;
    margin: 0 auto;
}
.case_btn li{
    border-radius: 30px;
    width: 166px;
    height: 51px;
    float: left;
    margin-right: 10px;
    text-align: center;
    line-height: 51px;
    color: #fff;
    border: 1px solid #a5a6a7;
    cursor: pointer;
}
.lishow{
    background: #1a7cf8;
    border: none!important;
}
.case_btn li:nth-child(3){
    margin: 0;
}
.case_cennert{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.case_cennert h1{
    font-size: 36px;
    letter-spacing:1px;
    text-align: center;
    padding-top: 80px;
    margin-bottom: 15px;
    margin-left: 17px;
    color:#fff;
}
.case_cennert P{
    font-size: 18px;
    color:#fff;
    text-align: center;
    margin-bottom: 50px;
}
.cal_list{
    margin-top: 37px;
}
.cal_list li{
    width: 363px;
    height: 354px;
    background: #ffffff;
    float: left;
    margin-bottom: 57px;
    margin-right: 50px;
}
.cal_list li:nth-child(3){
    margin: 0;
}
.cal_list_top{
    height: 210px;
    width: 100%;
    position: relative;
}
.cal_list_top img{
    width: 100%;
    height: 100%;
}
.erweima {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  cursor: pointer;
}
#qrcode{
  margin: 0 auto;
  position: relative;
  width: 109px; 
  height: 112px;
  z-index: 2;
  overflow: hidden;
  padding: 5px 5px 4px 5px;
  background: #fff;
  margin-top: 25px;
  margin-bottom: 11px;
}
.qrcode_Mask{
    width: 100%;
    /* height: 10px; */
    background: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
}
.qrcode_btn{
    text-align: center;
    width: 95px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;
    margin: 0 auto;
}
.cal_list_bottom{
    padding: 29px 0px 0px 20px;
    width: 312px;
    height: 100px;
}
.cal_list_bottom h3{
    margin-bottom: 10px;
}
.cal_list_bottom p{
    font-size: 15px;
    color: #656565;
    text-align: left;
}
.case_go{
    width: 156px;
    height: 42px;
    border: 1px solid #fff;
    text-align: center;
    line-height: 42px;
    color: #fff;
    clear: both;
    cursor: pointer;
    margin: 0 auto;
}
.case_go a{
    color: #fff;
    transition: 0.5s all;
    
}
.case_go:hover{
    font-size: 17px;
}
.VR_style{
  width: 1352px;
  height: 803px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 999;
  background: #fff;
  padding: 15px 15px 15px 15px;
  transform: translate(-50%,-50%);
  border-radius: 10px;
  z-index: 1;
  position: relative;
 
}
#iframe{
  width: 100%;
  height: 100%;
  opacity: 0.8;
  transition: 1s all; 
   border-radius: 10px;
}
.close{
  width: 40px;
  height: 37px;
  background: red;
  position: absolute;
  right: -64px;
  top:-34px;
  z-index: 999;
  background: url("../../assets/imges/close.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

/* 加载条代码 */
.loader {
    background: #000;
    background: radial-gradient(#222, #000);
    overflow: hidden;
    z-index: 99999;
    overflow: hidden;
    position: absolute;
    left: 15px;
    top: 15px;
 width: 1352px;
  height: 803px;
    border-radius: 10px;
}

.loader-inner {
    bottom: 0;
    height: 60px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}

.loader-line-wrap {
    animation: 
		spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite
	;
    box-sizing: border-box;
    height: 50px;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    transform-origin: 50% 100%;
    width: 100px;
}
.loader-line {
    border: 4px solid transparent;
    border-radius: 100%;
    box-sizing: border-box;
    height: 100px;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}
.loader-line-wrap:nth-child(1) { animation-delay: -50ms; }
.loader-line-wrap:nth-child(2) { animation-delay: -100ms; }
.loader-line-wrap:nth-child(3) { animation-delay: -150ms; }
.loader-line-wrap:nth-child(4) { animation-delay: -200ms; }
.loader-line-wrap:nth-child(5) { animation-delay: -250ms; }

.loader-line-wrap:nth-child(1) .loader-line {
    border-color: hsl(0, 80%, 60%);
    height: 90px;
    width: 90px;
    top: 7px;
}
.loader-line-wrap:nth-child(2) .loader-line {
    border-color: hsl(60, 80%, 60%);
    height: 76px;
    width: 76px;
    top: 14px;
}
.loader-line-wrap:nth-child(3) .loader-line {
    border-color: hsl(120, 80%, 60%);
    height: 62px;
    width: 62px;
    top: 21px;
}
.loader-line-wrap:nth-child(4) .loader-line {
    border-color: hsl(180, 80%, 60%);
    height: 48px;
    width: 48px;
    top: 28px;
}
.loader-line-wrap:nth-child(5) .loader-line {
    border-color: hsl(240, 80%, 60%);
    height: 34px;
    width: 34px;
    top: 35px;
}
@keyframes spin {
    0%, 15% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>


// WEBPACK FOOTER //
// src/common/PanoramicLive/PanoramicLive_case.vue